//import './scss/index.scss';
import { dcFactory } from 'dc';
import TabsComponent from './js/tabs.component.js';

dcFactory.register(TabsComponent);
